export const MaritalStatus = [
    { value: 'Single', label: 'Single' },
    { value: 'Engaged', label: 'Engaged' },
    { value: 'Widowed', label: 'Widowed' },
    { value: 'Separated', label: 'Separated' },
    { value: 'Married', label: 'Married' },
    { value: 'Divorced', label: 'Divorced' },
];
